<template>
  <v-card v-if="channels.length" class="mb-4 rounded-lg" outlined>
    <v-card-title class="d-flex align-center">
      <v-icon left small>fal fa-tags</v-icon>
      {{ $t("channel_prices") }}
    </v-card-title>
    <v-card-text>
      <v-row dense>
        <v-col
          v-for="channel in channels"
          :key="channel.id"
          cols="12"
          sm="6"
        >
          <div class="channel-price-row">
            <v-switch
              :input-value="isChannelEnabled(channel.id)"
              color="primary"
              inset
              hide-details
              class="mt-0 pt-0 mr-3"
              @change="toggleChannel(channel.id, $event)"
            />
            <div class="channel-price-content">
              <div class="channel-name">
                <v-avatar v-if="channel.icon" size="24" class="mr-2">
                  <app-img :img="channel.icon" width="24" height="24" />
                </v-avatar>
                <span>{{ channel.name }}</span>
              </div>
              <v-text-field
                :value="getChannelPrice(channel.id)"
                :disabled="!isChannelEnabled(channel.id)"
                :suffix="currency"
                type="number"
                min="0"
                step="1"
                outlined
                dense
                hide-details="auto"
                class="mt-2"
                @input="updateChannelPrice(channel.id, $event)"
              />
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    currency: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      channels: [],
      rows: [],
      syncing: false,
    };
  },
  created() {
    this.fetchChannels();
    this.syncRows(this.value);
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        if (!this.syncing) {
          this.syncRows(value);
        }
      },
    },
  },
  methods: {
    async fetchChannels() {
      try {
        const { data } = await this.$http.get("price_channels?is_active=1");
        this.channels = Array.isArray(data?.data) ? data.data : [];
      } catch (error) {
        this.channels = [];
      }
    },
    syncRows(value) {
      const prices = Array.isArray(value) ? value : [];
      this.rows = prices
        .filter((item) => item && item.price_channel_id)
        .map((item) => ({
          price_channel_id: item.price_channel_id,
          price: item.price === null || item.price === undefined ? "" : item.price,
          is_active:
            item.is_active === false || item.is_active === 0 ? 0 : 1,
        }));
    },
    isChannelEnabled(channelId) {
      return this.rows.some(
        (row) => row.price_channel_id === channelId && row.is_active !== 0
      );
    },
    getChannelPrice(channelId) {
      const found = this.rows.find((row) => row.price_channel_id === channelId);
      return found ? found.price : "";
    },
    toggleChannel(channelId, enabled) {
      const found = this.rows.find((row) => row.price_channel_id === channelId);
      if (enabled) {
        if (found) {
          found.is_active = 1;
        } else {
          this.rows.push({
            price_channel_id: channelId,
            price: "",
            is_active: 1,
          });
        }
      } else if (found) {
        this.rows = this.rows.filter((row) => row.price_channel_id !== channelId);
      }
      this.emitRows();
    },
    updateChannelPrice(channelId, value) {
      const found = this.rows.find((row) => row.price_channel_id === channelId);
      if (!found) {
        return;
      }
      const amount = value === "" || value === null ? "" : Number(value);
      found.price = amount < 0 ? 0 : amount;
      this.emitRows();
    },
    emitRows() {
      const payload = this.rows
        .filter((row) => row.is_active !== 0 && row.price !== "")
        .map((row) => ({
          price_channel_id: row.price_channel_id,
          price: Number(row.price),
          is_active: 1,
        }));

      this.syncing = true;
      this.$emit("input", payload);
      this.$nextTick(() => {
        this.syncing = false;
      });
    },
  },
};
</script>

<style scoped>
.channel-price-row {
  display: flex;
  align-items: flex-start;
  min-height: 88px;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.channel-price-content {
  flex: 1;
  min-width: 0;
}

.channel-name {
  display: flex;
  align-items: center;
  min-height: 24px;
  font-weight: 500;
}
</style>
